"use client";

import { z } from "zod";

export const itemStockUnitFormSchema = z.object({
  name: z.string().min(1, { message: "Required" }),
  description: z.string().optional(),
});
